"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), __jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, __jsx("path", {
    d: "M-1380-1246H540v4595h-1920z"
  }), __jsx("path", {
    d: "M5.556 0A5.556 5.556 0 000 5.556v8.888A5.556 5.556 0 005.556 20h8.888A5.556 5.556 0 0020 14.444V5.556A5.556 5.556 0 0014.444 0H5.556zm11.11 2.222c.612 0 1.112.5 1.112 1.111s-.5 1.111-1.111 1.111-1.111-.5-1.111-1.11c0-.612.5-1.112 1.11-1.112zM10 4.444a5.556 5.556 0 110 11.112 5.556 5.556 0 010-11.112zm0 2.223a3.334 3.334 0 00.002 6.669A3.335 3.335 0 0010 6.666z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
var _default = exports.default = SvgComponent;